module.exports = __webpack_public_path__ + "static/img/LOGAN-MORRIS.ef1a2c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LOGAN-MORRIS.jpg
// module id = hJO6
// module chunks = 0